module.exports = __webpack_public_path__ + "31a7299d.png";